import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconTag"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4.5C2 3.11929 3.11929 2 4.5 2H11.1716C11.8346 2 12.4705 2.26339 12.9393 2.73223L21.4393 11.2322C22.4157 12.2085 22.4157 13.7915 21.4393 14.7678L14.7678 21.4393C13.7915 22.4157 12.2085 22.4157 11.2322 21.4393L2.73223 12.9393C2.26339 12.4705 2 11.8346 2 11.1716V4.5ZM7 8.5C7.82843 8.5 8.5 7.82843 8.5 7C8.5 6.17157 7.82843 5.5 7 5.5C6.17157 5.5 5.5 6.17157 5.5 7C5.5 7.82843 6.17157 8.5 7 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTag;
